import {FiArrowRight} from "react-icons/fi";
import {useForm} from "react-hook-form";
import {useToasts} from "react-toast-notifications";
import classNames from "classnames";
import axios from "axios";
import config from "../config.json";

const AccountForm = ({userDetail})=>{
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting, isSubmitSuccessful },
    } = useForm();
    const { addToast } = useToasts();
    const doUpdate = async ()=>{
        axios({
            url: `/api/user-update`,
            headers: config.api.headers,
            method: 'post',
            data: {
                nombre: event.target.name.value,
                apellidos: event.target.lastname.value,
                email: event.target.email.value,
                telefono_local: event.target.phone.value,
                telefono_cel: event.target.cellphone.value,
                genero: event.target.gender.value
            }
        })
            .then(d=>{
                addToast( d.data.message, { appearance: 'success', autoDismiss: true });
            })
            .catch(e=>{
                addToast( 'cierra y vuelve a iniciar sesion para poder actualizar tus datos', { appearance: 'error', autoDismiss: true });
            })
    };
    return <div className="accountForm">
        <form onSubmit={handleSubmit(doUpdate)} >
            <div className={classNames('inputItem', { 'inputItem-error' :  errors?.name?.message})}>
                <div>
                    <label>Nombre(s)</label>
                    <input type="text"
                           defaultValue={userDetail.nombre}
                           {...register('name', {
                               required: { value: true, message: 'Escribe tu nombre' }
                           })}
                    />
                </div>
                <span className="inputError">{errors?.name?.message}</span>
            </div>
            <div className={classNames('inputItem', { 'inputItem-error' :  errors?.lastname?.message})}>
                <div>
                    <label>Apellidos</label>
                    <input type="text"
                           defaultValue={userDetail.apellidos}
                           {...register('lastname', {
                               required: { value: true, message: 'Escribe tu apellido' }
                           })}
                    />
                </div>
                <span className="inputError">{errors?.lastname?.message}</span>
            </div>
            <div className={classNames('inputItem', { 'inputItem-error' :  errors?.email?.message})}>
                <div>
                    <label>Email</label>
                    <input type="text"
                           defaultValue={userDetail.email}
                           {...register('email', {
                               required: {
                                   value: true,
                                   message: 'Escribe tu email',
                                   pattern: {
                                       value: /\S+@\S+\.\S+/,
                                       message: 'Escribe un email valido'
                                   }
                               }
                           })}
                    />
                </div>
                <span className="inputError">{errors?.email?.message}</span>
            </div>
            <div className={classNames('inputItem', { 'inputItem-error' :  errors?.phone?.message})}>
                <div>
                    <label>Telefono</label>
                    <input type="text"
                           defaultValue={userDetail.telefono_local}
                           {...register('phone', {
                               required: { value: true, message: 'Escribe tu telefono' }
                           })}
                    />
                </div>
                <span className="inputError">{errors?.phone?.message}</span>
            </div>
            <div className={classNames('inputItem', { 'inputItem-error' :  errors?.cellphone?.message})}>
                <div>
                    <label>Celular</label>
                    <input type="text"
                           defaultValue={userDetail.telefono_cel}
                           {...register('cellphone', {
                               required: { value: true, message: 'Escribe tu celular' }
                           })}
                    />
                </div>
                <span className="inputError">{errors?.cellphone?.message}</span>
            </div>
            <div className={classNames('inputItem', { 'inputItem-error' :  errors?.gender?.message})}>
                <div>
                    <label>Genero</label>
                    <select
                        defaultValue={userDetail.genero}
                        {...register('gender', {
                            required: { value: true, message: 'Selecciona tu genero' }
                        })}>
                        <option value="">Selecciona una opción</option>
                        <option value="M">Masculino</option>
                        <option value="F">Femenino</option>
                    </select>
                </div>
                <span className="inputError">{errors?.gender?.message}</span>
            </div>
            <button className="button">Actualizar información <FiArrowRight/></button>
        </form>
    </div>
};

export default AccountForm;